import { ChangeEvent } from "react";

import { TableFilterProps } from "./TableFilter.types";
import styles from "./TableFilter.module.scss";

interface BooleanFilterValue {
  isTrue: boolean;
  isFalse: boolean;
}

export const BooleanFilterComponent: React.FC<TableFilterProps> = ({ value, onChange }) => {
  const filterValue = (value as BooleanFilterValue | undefined) ?? { isTrue: false, isFalse: false };

  const updateValue = (key: keyof BooleanFilterValue, checked: boolean) => {
    const nextValue = { ...filterValue, [key]: checked };
    onChange(!nextValue.isTrue && !nextValue.isFalse ? undefined : nextValue);
  };

  return (
    <div className={styles.booleanOptions} onClick={(event) => event.stopPropagation()}>
      <label className={styles.booleanOption}>
        <input
          type="checkbox"
          checked={filterValue.isTrue}
          onChange={(event: ChangeEvent<HTMLInputElement>) => updateValue("isTrue", event.target.checked)}
        />
        <span>True</span>
      </label>
      <label className={styles.booleanOption}>
        <input
          type="checkbox"
          checked={filterValue.isFalse}
          onChange={(event: ChangeEvent<HTMLInputElement>) => updateValue("isFalse", event.target.checked)}
        />
        <span>False</span>
      </label>
    </div>
  );
};